module.exports = __webpack_public_path__ + "static/media/php CMS.d9ee0ef8.pdf";